import { Box, Container, Grid, makeStyles } from "@material-ui/core";
import { GuaranteeIcon, AccountManagerIcon, WarrantyIcon12, WarrantyIcon24 } from "../../components/Icons";
import { EQuoteType } from "../../api/Types";
import { TF } from "../../components/typography/TF";

export const QuoteGuarantee = ({ type }: Props) => {
  const classes = useStyles();
  const guaranteePeriod =
    type === EQuoteType.Solar || type === EQuoteType.BoilerSolar ? (
      <WarrantyIcon24 className={classes.icon} />
    ) : (
      <WarrantyIcon12 className={classes.icon} />
    );
  return (
    <Box textAlign="center">
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TF variant="h5" bold paragraph>
              Swyft Guarantee
            </TF>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Container maxWidth="xs">
              <GuaranteeIcon className={classes.icon} />
              <TF variant="h6" paragraph>
                Swyft Energy
                <br />
                Happiness Guarantee
              </TF>
            </Container>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Container maxWidth="xs">
              {guaranteePeriod}
              <TF variant="h6" paragraph>
                Swyft Energy
                <br />
                Worksmanship Guarantee
              </TF>
            </Container>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Container maxWidth="xs">
              <AccountManagerIcon className={classes.icon} />
              <TF variant="h6" paragraph>
                Dedicated Account Manager <br />
                from start to finish
              </TF>
            </Container>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  icon: {
    height: "5rem",
    width: "5rem"
  }
}));

export interface Props {
  type?: EQuoteType;
}
